import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Typography, useDisableGlobalBanner } from 'shared/ui'
import { getCDNAssetURL } from 'shared/lib'
import { LINK_APP_STORE, LINK_GOOGLE_PLAY } from 'shared/constants/links'
import appStoreBadge from 'shared/assets/images/landingMobile/appStoreBadge.png'
import googlePlayBadge from 'shared/assets/images/landingMobile/googlePlayBadge.png'
import landingMobilePhone from 'shared/assets/images/landingMobilePagePhone.png'
import logoSalesmsgBlue from 'icons/logoSalesmsgBlue.svg'
import {
  ProviderLandingMobilePage,
  useLandingMobilePageContext,
} from 'pages/landingMobile/context/landingMobileContext'
import { LandingMobilePageStore } from 'pages/landingMobile/store/landingMobilePageStore'
import styles from './styles.module.scss'

const LandingMobilePageContent = observer(() => {
  const store = useLandingMobilePageContext()

  return (
    <div className={styles.wrap}>
      <div className={styles.logo}>
        <img className={styles.logoImage} alt='Salesmsg' src={logoSalesmsgBlue} />
      </div>

      <div className={styles.content}>
        <Typography
          ariaLabel='LandingMobileTitle'
          variant={'body-xl-semibold'}
          className={styles.title}
        >
          {store.title}
        </Typography>

        <Typography
          className={styles.description}
          variant={'body-lg-medium'}
          ariaLabel={'LandingMobileDescription'}
        >
          {store.description}
        </Typography>

        <div className={styles.badgesWrap}>
          <a href={LINK_APP_STORE} target='_blank' rel='noreferrer'>
            <img className={styles.badge} alt='appStore' src={getCDNAssetURL(appStoreBadge)} />
          </a>
          <a href={LINK_GOOGLE_PLAY} target='_blank' rel='noreferrer'>
            <img className={styles.badge} alt='googlePlay' src={getCDNAssetURL(googlePlayBadge)} />
          </a>
        </div>

        <Button
          typeBtn={'link'}
          text={
            <Typography variant={'body-rg-medium'} ariaLabel={'LandingMobileContinue_text'}>
              Continue on web
            </Typography>
          }
          onClick={store.continueToApp}
          aria-label={'LandingMobileContinue'}
          className={styles.continueLink}
          color={'var(--content-primary-tertiary)'}
          size={'large'}
        />
      </div>

      <img
        className={styles.phoneImage}
        alt='landingMobilePhone'
        src={getCDNAssetURL(landingMobilePhone)}
      />
    </div>
  )
})

export const LandingMobilePage = () => {
  const store = useMemo(() => new LandingMobilePageStore(), [])

  useDisableGlobalBanner()

  return (
    <ProviderLandingMobilePage value={store}>
      <LandingMobilePageContent />
    </ProviderLandingMobilePage>
  )
}
